import { render, staticRenderFns } from "./TaskStatistics.vue?vue&type=template&id=4284d9e2&scoped=true"
import script from "./TaskStatistics.vue?vue&type=script&lang=js"
export * from "./TaskStatistics.vue?vue&type=script&lang=js"
import style0 from "./TaskStatistics.vue?vue&type=style&index=0&id=4284d9e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284d9e2",
  null
  
)

export default component.exports